import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../modules/shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';

// ABOUT SCREENS
import { AboutUsComponent } from '../screens/about-us/about-us.component';
import { OurHistoryComponent } from '../screens/about-us/our-history/our-history.component';
import { VisionMissionComponent as AboutVisionMissionComponent } from '../screens/about-us/vision-mission/vision-mission.component';
import { PrincipalMessageComponent } from '../screens/about-us/principal-message/principal-message.component';
import { CodeOfConductComponent } from '../screens/about-us/code-of-conduct/code-of-conduct.component';
import { CollegeAnthemComponent } from '../screens/about-us/college-anthem/college-anthem.component';
import { PrayerComponent } from '../screens/about-us/prayer/prayer.component';

// HEI SCREENS
import { HeiComponent } from '../screens/hei/hei.component';
import { AboutSsgcComponent } from '../screens/hei/about-ssgc/about-ssgc.component';
import { ActStatutesComponent } from '../screens/hei/act-statutes/act-statutes.component';
import { InstitutionalDevPlanComponent } from '../screens/hei/institutional-dev-plan/institutional-dev-plan.component';
import { AffiliationComponent } from '../screens/hei/affiliation/affiliation.component';
import { RankingComponent } from '../screens/hei/ranking/ranking.component';
import { AnnualReportsComponent } from '../screens/hei/annual-reports/annual-reports.component';

// ADMINISTRATION SCREENS
import { AdminComponent } from '../screens/admin/admin.component';
import { GoverningBodyComponent } from '../screens/admin/governing-body/governing-body.component';
import { PrincipalComponent as AdminPrincipalComponent } from '../screens/admin/principal/principal.component';
import { OmbudsmanComponent } from '../screens/admin/ombudsman/ombudsman.component';
import { ExecutiveCouncilComponent } from '../screens/admin/executive-council/executive-council.component';
import { IccComponent } from '../screens/admin/icc/icc.component';
import { HodsComponent } from '../screens/admin/hods/hods.component';
import { BoardOfStudiesComponent } from '../screens/admin/board-of-studies/board-of-studies.component';
import { CdcComponent } from '../screens/admin/cdc/cdc.component';

// ACADEMICS SCREENS
import { AcademicsComponent } from '../screens/academics/academics.component';
import { ProgramsComponent } from '../screens/academics/programs/programs.component';
import { TimeTableComponent } from '../screens/academics/time-table/time-table.component';
import { ValueAddedCoursesComponent } from '../screens/academics/value-added-courses/value-added-courses.component';
import { SyllabusComponent } from '../screens/academics/syllabus/syllabus.component';
import { CalendarComponent } from '../screens/academics/calendar/calendar.component';

// FACULTY SCREENS
import { FacultyComponent } from '../screens/faculty/faculty.component';
import { TeachingStaffComponent } from '../screens/faculty/teaching/teaching.component';
import { NonTeachingStaffComponent } from '../screens/faculty/non-teaching/non-teaching.component';

// DEPARTMENT SCREENS
import { DepartmentComponent } from '../screens/department/department.component';
import { ChemistryComponent } from '../screens/department/chemistry/chemistry.component';
import { CommerceManagementComponent } from '../screens/department/commerce-management/commerce-management.component';
import { ComputerScienceComponent } from '../screens/department/computer-science/computer-science.component';
import { EconomicsComponent } from '../screens/department/economics/economics.component';
import { EnglishComponent } from '../screens/department/english/english.component';
import { GeographyComponent } from '../screens/department/geography/geography.component';
import { HindiComponent } from '../screens/department/hindi/hindi.component';
import { HomeScienceComponent } from '../screens/department/home-science/home-science.component';
import { MassCommunicationComponent } from '../screens/department/mass-communication/mass-communication.component';
import { MathematicsComponent } from '../screens/department/mathematics/mathematics.component';
import { PhysicalEducationComponent } from '../screens/department/physical-education/physical-education.component';
import { PhysicsComponent } from '../screens/department/physics/physics.component';
import { PsychologyComponent } from '../screens/department/psychology/psychology.component';
import { PunjabiComponent } from '../screens/department/punjabi/punjabi.component';
import { PublicAdministrationComponent } from '../screens/department/public-administration/public-administration.component';

// ADMISSION SCREENS
import { AdmissionsComponent } from '../screens/admissions/admissions.component';
import { ProspectusComponent } from '../screens/admissions/prospectus/prospectus.component';
import { UgComponent } from '../screens/admissions/ug/ug.component';
import { PgComponent } from '../screens/admissions/pg/pg.component';
import { RegistrationComponent as AdmissionRegistrationComponent } from '../screens/admissions/registration/registration.component';
import { FeesScholarshipsComponent } from '../screens/admissions/fees-scholarships/fees-scholarships.component';

// IQAC SCREENS
import { IqacComponent } from '../screens/iqac/iqac.component';
import { AboutIqacComponent } from '../screens/iqac/about-iqac/about-iqac.component';
import { FormationComponent } from '../screens/iqac/formation/formation.component';
import { IqacMeetingsComponent } from '../screens/iqac/iqac-meetings/iqac-meetings.component';
import { InstitutionalDistComponent } from '../screens/iqac/institutional-dist/institutional-dist.component';
import { QualityInitiativesComponent } from '../screens/iqac/quality-initiatives/quality-initiatives.component';
import { QualityAuditsComponent } from '../screens/iqac/quality-audits/quality-audits.component';
import { CollaborativeInitiativesComponent } from '../screens/iqac/collaborative-initiatives/collaborative-initiatives.component';
import { ConferenceSeminarsWorkshopsComponent } from '../screens/iqac/conference-seminars-workshops/conference-seminars-workshops.component';
import { AisheComponent } from '../screens/iqac/aishe/aishe.component';
import { NirfComponent } from '../screens/iqac/nirf/nirf.component';
import { AqarComponent } from '../screens/iqac/aqar/aqar.component';
import { AccreditationComponent } from '../screens/iqac/accreditation/accreditation.component';
import { FeedbackComponent } from '../screens/iqac/feedback/feedback.component';
import { BestPracComponent } from '../screens/iqac/best-prac/best-prac.component';
import { BuildingStrongerComponent } from '../screens/iqac/best-prac/building-stronger/building-stronger.component';
import { GoGreenComponent } from '../screens/iqac/best-prac/go-green/go-green.component';
import { YogaMeditationComponent } from '../screens/iqac/best-prac/yoga-meditation/yoga-meditation.component';

// STUDENT LIFE SCREENS
import { CampusLifeComponent } from '../screens/campus-life/campus-life.component';
import { SmartClassroomsComponent } from '../screens/campus-life/facilities/smart-classrooms/smart-classrooms.component';
import { MediaLabComponent } from '../screens/campus-life/facilities/media-lab/media-lab.component';
import { ComputerLabComponent } from '../screens/campus-life/facilities/computer-lab/computer-lab.component';
import { ScienceLabComponent } from '../screens/campus-life/facilities/science-lab/science-lab.component';
import { NccComponent } from '../screens/campus-life/ncc/ncc.component';
import { NssComponent } from '../screens/campus-life/nss/nss.component';
import { YouthRedCrossComponent } from '../screens/campus-life/youth-red-cross/youth-red-cross.component';
import { RedRibbonClubComponent } from '../screens/campus-life/red-ribbon-club/red-ribbon-club.component';
import { GrievancesIccComponent } from '../screens/campus-life/grievances-icc/grievances-icc.component';
import { CampusFacilitiesComponent } from '../screens/campus-life/campus-facilities/campus-facilities.component';
import { GreenCampusComponent } from '../screens/campus-life/green-campus/green-campus.component';
import { BestPracticesComponent } from '../screens/campus-life/best-practices/best-practices.component';

// STUDENT FACILITIES SCREENS
import { SportsComponent } from '../screens/student-facilities/sports/sports.component';
import { CultureMusicComponent } from '../screens/student-facilities/culture-music/culture-music.component';
import { ScholarshipComponent } from '../screens/student-facilities/scholarship/scholarship.component';
import { HealthComponent } from '../screens/student-facilities/health/health.component';
import { CareerGuidanceComponent } from '../screens/student-facilities/career-guidance/career-guidance.component';

// GRIEVANCES SCREENS
import { GrievancesComponent } from '../screens/grievances/grievances.component';
import { SubmitComponent } from '../screens/grievances/submit/submit.component';
import { ObjectivesComponent } from '../screens/grievances/objectives/objectives.component';
import { FunctionsComponent } from '../screens/grievances/functions/functions.component';
import { OmbudspersonComponent } from '../screens/grievances/ombudsperson/ombudsperson.component';
import { CommitteeComponent } from '../screens/grievances/committee/committee.component';
import { RedressalComponent } from '../screens/grievances/redressal/redressal.component';
import { PolicyComponent } from '../screens/grievances/policy/policy.component';

// RESEARCH
import { ResearchComponent } from '../screens/research/research.component';

// ALUMNI
import { AlumniComponent } from '../screens/alumni/alumni.component';
import { AlumniMeetComponent } from '../screens/alumni/alumni-meet/alumni-meet.component';

// VISIT
import { VisitComponent } from '../screens/visit/visit.component';
import { HowToReachComponent } from '../screens/visit/how-to-reach/how-to-reach.component';
import { CityMapComponent } from '../screens/visit/city-map/city-map.component';

// INFO
import { InfoComponent } from '../screens/info/info.component';
import { NewslettersComponent } from '../screens/info/newsletters/newsletters.component';
import { NotificationsComponent } from '../screens/info/notifications/notifications.component';
import { JobOpeningsComponent } from '../screens/info/job-openings/job-openings.component';
import { RtiDetailsComponent } from '../screens/info/rti-details/rti-details.component';
import { RecentEventsComponent } from '../screens/info/recent-events/recent-events.component';

// MISC
import { MousComponent } from '../screens/mous/mous.component';
import { InternshipsComponent } from '../screens/internships/internships.component';
import { PlacementsComponent } from '../screens/placements/placements.component';
import { ContactComponent } from '../screens/contact/contact.component';

// LIBRARY SCREENS
import { LibraryComponent } from '../screens/library/library.component';
import { AboutLibraryComponent } from '../screens/library/about-library/about-library.component';
import { VisionMissionComponent as LibraryVisionMissionComponent } from '../screens/library/vision-mission/vision-mission.component';
import { AdvisoryCommitteeComponent } from '../screens/library/advisory-committee/advisory-committee.component';
import { LibraryTimingsComponent } from '../screens/library/library-timings/library-timings.component';
import { LibraryRulesComponent } from '../screens/library/library-rules/library-rules.component';
import { BorrowingFacilityComponent } from '../screens/library/borrowing-facility/borrowing-facility.component';
import { IssueReturnComponent } from '../screens/library/issue-return/issue-return.component';
import { EResourcesComponent } from '../screens/library/e-resources/e-resources.component';
import { MoocsComponent } from '../screens/library/moocs/moocs.component';
import { QuestionBankComponent } from '../screens/library/question-bank/question-bank.component';
import { LibraryActivitiesComponent } from '../screens/library/library-activities/library-activities.component';

// NEW MISSING SCREENS
import { RDCellComponent } from '../screens/research/rd-cell/rd-cell.component';
import { IncubationCentreComponent } from '../screens/research/incubation/incubation.component';
import { NListComponent } from '../screens/library/n-list/n-list.component';
import { OurAlumnusComponent } from '../screens/alumni/our-alumnus/our-alumnus.component';
import { InfrastructureComponent } from '../screens/visit/infrastructure/infrastructure.component';
import { GalleryComponent } from '../screens/gallery/gallery.component';
import { EmailDirectoryComponent } from '../screens/contact/email-directory/email-directory.component';
import { TelephoneDirectoryComponent } from '../screens/contact/telephone-directory/telephone-directory.component';
import { ContactInfoComponent } from '../screens/contact/contact-info/contact-info.component';
import { AlumniLandingComponent } from '../screens/alumni/alumni-landing/alumni-landing.component';
import { StudentFacilitiesComponent } from '../screens/student-facilities/student-facilities.component';

// QUICK LINKS SCREEN IMPORTS
import { SafetySecurityComponent } from '../screens/quick-links-home/safety-security/safety-security.component';
import { EResourceComponent } from '../screens/quick-links-home/e-resource/e-resource.component';
import { FinancialWelfareComponent } from '../screens/quick-links-home/financial-welfare/financial-welfare.component';
import { EducationalTripsComponent } from '../screens/quick-links-home/educational-trips/educational-trips.component';
import { AwardsComponent } from '../screens/quick-links-home/awards/awards.component';
import { GirlGuidesScoutsComponent } from '../screens/quick-links-home/girl-guides-scouts/girl-guides-scouts.component';
import { WorldRecordComponent } from '../screens/quick-links-home/world-record/world-record.component';
import { AthleticMeetComponent } from '../screens/quick-links-home/athletic-meet/athletic-meet.component';
import { SummerSportsCampComponent } from '../screens/quick-links-home/summer-sports-camp/summer-sports-camp.component';
import { CollegeInNewsComponent } from '../screens/quick-links-home/college-in-news/college-in-news.component';
import { SeminarsWorkshopsComponent } from '../screens/quick-links-home/seminars-workshops/seminars-workshops.component';
import { YouthFestivalComponent } from '../screens/quick-links-home/youth-festival/youth-festival.component';
import { CampusOverviewComponent } from '../screens/quick-links-home/campus-overview/campus-overview.component';
import { LatestInCollegeComponent } from '../screens/quick-links-home/latest-in-college/latest-in-college.component';
import { GeographyLabComponent } from '../screens/campus-life/facilities/geography-lab/geography-lab.component';
import { PsychologyLabComponent } from '../screens/campus-life/facilities/psychology-lab/psychology-lab.component';
import { DanceRoomComponent } from '../screens/campus-life/facilities/dance-room/dance-room.component';
import { FreeshipComponent } from '../screens/student-facilities/freeship/freeship.component';
import { RemedialClassesComponent } from '../screens/student-facilities/remedial-classes/remedial-classes.component';
import { AntiRaggingCellComponent } from '../screens/student-facilities/anti-ragging-cell/anti-ragging-cell.component';
import { EqualOpportunityCellComponent } from '../screens/student-facilities/equal-opportunity-cell/equal-opportunity-cell.component';
import { DifferentlyAbledComponent } from '../screens/student-facilities/differently-abled/differently-abled.component';
import { SkillOrientedCoursesComponent } from '../screens/quick-links-home/skill-oriented-courses/skill-oriented-courses.component';
import { BestPracticesHomeComponent } from '../screens/home-sections/best-practices-home/best-practices-home.component';
import { FaqComponent } from '../screens/home-sections/faq/faq.component';
import { StudentLifeHomeComponent } from '../screens/home-sections/student-life-home/student-life-home.component';
import { PublicSelfDisclosureComponent } from '../screens/public-self-disclosure/public-self-disclosure.component';
import { StudentStrengthComponent } from '../screens/academics/student-strength/student-strength.component';

// EXCELLENCE SCREENS
import { BheemAwardeesComponent } from '../screens/excellence/bheem-awardees/bheem-awardees.component';
import { InternationalPlayersComponent } from '../screens/excellence/international-players/international-players.component';
import { NationalPlayersComponent } from '../screens/excellence/national-players/national-players.component';
import { UniversityRankersComponent } from '../screens/excellence/university-rankers/university-rankers.component';
import { StatePlayersComponent } from '../screens/excellence/state-players/state-players.component';
import { MeritoriousStudentsComponent } from '../screens/excellence/meritorious-students/meritorious-students.component';

const routes: Routes = [
  // ABOUT US
  {
    path: 'about-us',
    component: AboutUsComponent,
    children: [
      { path: 'our-history', component: OurHistoryComponent },
      { path: 'vision-mission', component: AboutVisionMissionComponent },
      { path: 'principal-message', component: PrincipalMessageComponent },
      { path: 'code-of-conduct', component: CodeOfConductComponent },
      { path: 'college-anthem', component: CollegeAnthemComponent },
      { path: 'prayer', component: PrayerComponent },
      { path: '', redirectTo: 'our-history', pathMatch: 'full' },
    ],
  },

  // HEI
  {
    path: 'hei',
    component: HeiComponent,
    children: [
      { path: 'about-ssgc', component: AboutSsgcComponent },
      { path: 'act-statutes', component: ActStatutesComponent },
      { path: 'institutional-dev-plan', component: InstitutionalDevPlanComponent },
      { path: 'affiliation', component: AffiliationComponent },
      { path: 'ranking', component: RankingComponent },
      { path: 'annual-reports', component: AnnualReportsComponent },
      { path: '', redirectTo: 'about-ssgc', pathMatch: 'full' },
    ],
  },

  // ADMINISTRATION
  {
    path: 'admin',
    component: AdminComponent,
    children: [
      { path: 'governing-body', component: GoverningBodyComponent },
      { path: 'principal', component: AdminPrincipalComponent },
      { path: 'ombudsman', component: OmbudsmanComponent },
      { path: 'executive-council', component: ExecutiveCouncilComponent },
      { path: 'icc', component: IccComponent },
      { path: 'hods', component: HodsComponent },
      { path: 'board-of-studies', component: BoardOfStudiesComponent },
      { path: 'cdc', component: CdcComponent },
      { path: '', redirectTo: 'governing-body', pathMatch: 'full' },
    ],
  },

  // ACADEMICS
  {
    path: 'academics',
    component: AcademicsComponent,
    children: [
      { path: 'programs', component: ProgramsComponent },
      { path: 'time-table', component: TimeTableComponent },
      { path: 'value-added-courses', component: ValueAddedCoursesComponent },
      { path: 'syllabus', component: SyllabusComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'student-strength', component: StudentStrengthComponent },
      { path: '', redirectTo: 'programs', pathMatch: 'full' },
    ],
  },

  // FACULTY
  {
    path: 'faculty',
    component: FacultyComponent,
    children: [
      { path: 'teaching', component: TeachingStaffComponent },
      { path: 'non-teaching', component: NonTeachingStaffComponent },
      { path: '', redirectTo: 'teaching', pathMatch: 'full' },
    ],
  },

  // DEPARTMENT
  {
    path: 'department',
    component: DepartmentComponent,
    children: [
      { path: 'chemistry', component: ChemistryComponent },
      { path: 'commerce-management', component: CommerceManagementComponent },
      { path: 'computer-science', component: ComputerScienceComponent },
      { path: 'economics', component: EconomicsComponent },
      { path: 'english', component: EnglishComponent },
      { path: 'geography', component: GeographyComponent },
      { path: 'hindi', component: HindiComponent },
      { path: 'home-science', component: HomeScienceComponent },
      { path: 'mass-communication', component: MassCommunicationComponent },
      { path: 'mathematics', component: MathematicsComponent },
      { path: 'physical-education', component: PhysicalEducationComponent },
      { path: 'physics', component: PhysicsComponent },
      { path: 'psychology', component: PsychologyComponent },
      { path: 'punjabi', component: PunjabiComponent },
      { path: 'public-administration', component: PublicAdministrationComponent },
      { path: '', redirectTo: 'chemistry', pathMatch: 'full' },
    ],
  },

  // ADMISSIONS
  {
    path: 'admissions',
    component: AdmissionsComponent,
    children: [
      { path: 'prospectus', component: ProspectusComponent },
      { path: 'ug', component: UgComponent },
      { path: 'pg', component: PgComponent },
      { path: 'registration', component: AdmissionRegistrationComponent },
      { path: 'fees-scholarships', component: FeesScholarshipsComponent },
      { path: '', redirectTo: 'prospectus', pathMatch: 'full' },
    ],
  },

  // IQAC
  {
    path: 'iqac',
    component: IqacComponent,
    children: [
      { path: 'about-iqac', component: AboutIqacComponent },
      { path: 'formation', component: FormationComponent },
      { path: 'iqac-meetings', component: IqacMeetingsComponent },
      { path: 'institutional-dist', component: InstitutionalDistComponent },
      {
        path: 'best-prac',
        component: BestPracComponent,
        children: [
          { path: 'building-stronger-communities-through-education', component: BuildingStrongerComponent },
          { path: 'go-green-initiative', component: GoGreenComponent },
          { path: 'yoga-meditation', component: YogaMeditationComponent },
          { path: '', redirectTo: 'building-stronger-communities-through-education', pathMatch: 'full' }
        ]
      },
      { path: 'quality-initiatives', component: QualityInitiativesComponent },
      { path: 'quality-audits', component: QualityAuditsComponent },
      { path: 'collaborative-initiatives', component: CollaborativeInitiativesComponent },
      { path: 'conferences-seminars-workshops', component: ConferenceSeminarsWorkshopsComponent },
      { path: 'aishe', component: AisheComponent },
      { path: 'nirf', component: NirfComponent },
      { path: 'aqar', component: AqarComponent },
      { path: 'accreditation', component: AccreditationComponent },
      { path: 'feedback', component: FeedbackComponent },
      { path: '', redirectTo: 'about-iqac', pathMatch: 'full' },
    ],
  },

  // CAMPUS LIFE
  {
    path: 'campus-life',
    component: CampusLifeComponent,
    children: [
      { path: 'facilities/smart-classrooms', component: SmartClassroomsComponent },
      { path: 'facilities/media-lab', component: MediaLabComponent },
      { path: 'facilities/computer-lab', component: ComputerLabComponent },
      { path: 'facilities/science-lab', component: ScienceLabComponent },
      { path: 'facilities/geography-lab', component: GeographyLabComponent },
      { path: 'facilities/psychology-lab', component: PsychologyLabComponent },
      { path: 'facilities/dance-room', component: DanceRoomComponent },
      { path: 'ncc', component: NccComponent },
      { path: 'nss', component: NssComponent },
      { path: 'youth-red-cross', component: YouthRedCrossComponent },
      { path: 'red-ribbon-club', component: RedRibbonClubComponent },
      { path: 'grievances-icc', component: GrievancesIccComponent },
      { path: 'campus-facilities', component: CampusFacilitiesComponent },
      { path: 'green-campus', component: GreenCampusComponent },
      { path: 'best-practices', component: BestPracticesComponent },
      { path: '', redirectTo: 'facilities/smart-classrooms', pathMatch: 'full' },
    ],
  },

  // STUDENT FACILITIES
  {
    path: 'student-facilities',
    component: StudentFacilitiesComponent,
    children: [
      { path: 'sports', component: SportsComponent },
      { path: 'culture-music', component: CultureMusicComponent },
      { path: 'scholarship', component: ScholarshipComponent },
      { path: 'health', component: HealthComponent },
      { path: 'career-guidance', component: CareerGuidanceComponent },
      { path: 'freeship', component: FreeshipComponent },
      { path: 'remedial-classes', component: RemedialClassesComponent },
      { path: 'anti-ragging', component: AntiRaggingCellComponent },
      { path: 'equal-opportunity', component: EqualOpportunityCellComponent },
      { path: 'differently-abled', component: DifferentlyAbledComponent },
      { path: '', redirectTo: 'sports', pathMatch: 'full' }
    ],
  },

  // GRIEVANCES
  {
    path: 'grievances',
    component: GrievancesComponent,
    children: [
      { path: 'submit', component: SubmitComponent },
      { path: 'objectives', component: ObjectivesComponent },
      { path: 'functions', component: FunctionsComponent },
      { path: 'ombudsperson', component: OmbudspersonComponent },
      { path: 'committee', component: CommitteeComponent },
      { path: 'redressal', component: RedressalComponent },
      { path: 'policy', component: PolicyComponent },
      { path: '', redirectTo: 'submit', pathMatch: 'full' },
    ],
  },

  // RESEARCH
  {
    path: 'research',
    component: ResearchComponent,
    children: [
      { path: 'rd-cell', component: RDCellComponent },
      { path: 'incubation', component: IncubationCentreComponent },
      { path: '', component: ResearchComponent }
    ]
  },

  // ALUMNI
  {
    path: 'alumni',
    component: AlumniComponent,
    children: [
      { path: 'association', component: AlumniLandingComponent },
      { path: 'meet', component: AlumniMeetComponent },
      { path: 'our-alumnus', component: OurAlumnusComponent },
      { path: 'register', component: AlumniLandingComponent },
      { path: '', component: AlumniLandingComponent }
    ]
  },

  // VISIT
  {
    path: 'visit',
    component: VisitComponent,
    children: [
      { path: 'how-to-reach', component: HowToReachComponent },
      { path: 'city-map', component: CityMapComponent },
      { path: 'infrastructure', component: InfrastructureComponent },
      { path: '', redirectTo: 'how-to-reach', pathMatch: 'full' },
    ],
  },

  // INFO
  {
    path: 'info',
    component: InfoComponent,
    children: [
      { path: 'rti-details', component: RtiDetailsComponent },
      { path: 'job-openings', component: JobOpeningsComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'recent-events', component: RecentEventsComponent },
      { path: 'newsletters', component: NewslettersComponent },
      { path: '', redirectTo: 'rti-details', pathMatch: 'full' },
    ],
  },

  // LIBRARY
  {
    path: 'library',
    component: LibraryComponent,
    children: [
      { path: 'about-library', component: AboutLibraryComponent },
      { path: 'vision-mission', component: LibraryVisionMissionComponent },
      { path: 'advisory-committee', component: AdvisoryCommitteeComponent },
      { path: 'library-timings', component: LibraryTimingsComponent },
      { path: 'library-rules', component: LibraryRulesComponent },
      { path: 'borrowing-facility', component: BorrowingFacilityComponent },
      { path: 'issue-return', component: IssueReturnComponent },
      { path: 'e-resources', component: EResourcesComponent },
      { path: 'moocs', component: MoocsComponent },
      { path: 'question-bank', component: QuestionBankComponent },
      { path: 'library-activities', component: LibraryActivitiesComponent },
      { path: 'n-list', component: NListComponent },
      { path: '', redirectTo: 'about-library', pathMatch: 'full' },
    ],
  },

  // TOP LEVEL MISC
  { path: 'mous', component: MousComponent },
  { path: 'internships', component: InternshipsComponent },
  { path: 'placements', component: PlacementsComponent },
  { path: 'gallery', component: GalleryComponent },
  { path: 'nirf', component: NirfComponent },
  {
    path: 'contact',
    component: ContactComponent,
    children: [
      { path: 'email-directory', component: EmailDirectoryComponent },
      { path: 'telephone-directory', component: TelephoneDirectoryComponent },
      { path: '', component: ContactInfoComponent }
    ]
  },
  { path: 'contact-us', component: ContactComponent },

  // QUICK LINKS ROUTES
  { path: 'safety-security', component: SafetySecurityComponent },
  { path: 'e-resource-development-cell', component: EResourceComponent },
  { path: 'financial-support-and-welfare-works', component: FinancialWelfareComponent },
  { path: 'educational-trips', component: EducationalTripsComponent },
  { path: 'awards', component: AwardsComponent },
  { path: 'girl-guides-and-scouts', component: GirlGuidesScoutsComponent },
  { path: 'world-record', component: WorldRecordComponent },
  { path: 'athletic-meet', component: AthleticMeetComponent },
  { path: 'summer-sports-camp', component: SummerSportsCampComponent },
  { path: 'college-in-news', component: CollegeInNewsComponent },
  { path: 'seminars-and-workshops', component: SeminarsWorkshopsComponent },
  { path: 'youth-festival', component: YouthFestivalComponent },
  { path: 'campus-overview', component: CampusOverviewComponent },
  { path: 'latest-in-college', component: LatestInCollegeComponent },
  { path: 'skill-oriented-courses', component: SkillOrientedCoursesComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'best-practices-home', component: BestPracticesHomeComponent },
  { path: 'student-life-home', component: StudentLifeHomeComponent },
  { path: 'public-self-disclosure', component: PublicSelfDisclosureComponent },

  // EXCELLENCE ROUTES
  { path: 'bheem-awardees', component: BheemAwardeesComponent },
  { path: 'international-players', component: InternationalPlayersComponent },
  { path: 'national-players', component: NationalPlayersComponent },
  { path: 'university-rankers', component: UniversityRankersComponent },
  { path: 'state-players', component: StatePlayersComponent },
  { path: 'meritorious-students', component: MeritoriousStudentsComponent },

];

@NgModule({
  declarations: [
    // ABOUT US
    AboutUsComponent,
    OurHistoryComponent,
    AboutVisionMissionComponent,
    PrincipalMessageComponent,
    CodeOfConductComponent,
    CollegeAnthemComponent,
    PrayerComponent,

    // HEI
    HeiComponent,
    AboutSsgcComponent,
    ActStatutesComponent,
    InstitutionalDevPlanComponent,
    AffiliationComponent,
    RankingComponent,
    AnnualReportsComponent,

    // ADMINISTRATION
    AdminComponent,
    GoverningBodyComponent,
    AdminPrincipalComponent,
    OmbudsmanComponent,
    ExecutiveCouncilComponent,
    IccComponent,
    HodsComponent,
    BoardOfStudiesComponent,
    CdcComponent,

    // ACADEMICS
    AcademicsComponent,
    ProgramsComponent,
    TimeTableComponent,
    ValueAddedCoursesComponent,
    SyllabusComponent,
    CalendarComponent,
    StudentStrengthComponent,

    // FACULTY
    FacultyComponent,
    TeachingStaffComponent,
    NonTeachingStaffComponent,

    // DEPARTMENT
    DepartmentComponent,
    ChemistryComponent,
    CommerceManagementComponent,
    ComputerScienceComponent,
    EconomicsComponent,
    EnglishComponent,
    GeographyComponent,
    HindiComponent,
    HomeScienceComponent,
    MassCommunicationComponent,
    MathematicsComponent,
    PhysicalEducationComponent,
    PhysicsComponent,
    PsychologyComponent,
    PunjabiComponent,
    PublicAdministrationComponent,

    // ADMISSIONS
    AdmissionsComponent,
    ProspectusComponent,
    UgComponent,
    PgComponent,
    AdmissionRegistrationComponent,
    FeesScholarshipsComponent,

    // IQAC
    IqacComponent,
    AboutIqacComponent,
    FormationComponent,
    IqacMeetingsComponent,
    InstitutionalDistComponent,
    QualityInitiativesComponent,
    QualityAuditsComponent,
    CollaborativeInitiativesComponent,
    ConferenceSeminarsWorkshopsComponent,
    AisheComponent,
    NirfComponent,
    AqarComponent,
    AccreditationComponent,
    FeedbackComponent,
    BestPracComponent,
    BuildingStrongerComponent,
    GoGreenComponent,
    YogaMeditationComponent,

    // STUDENT LIFE
    CampusLifeComponent,
    SmartClassroomsComponent,
    MediaLabComponent,
    ComputerLabComponent,
    ScienceLabComponent,
    NccComponent,
    NssComponent,
    YouthRedCrossComponent,
    RedRibbonClubComponent,
    GrievancesIccComponent,
    CampusFacilitiesComponent,
    GreenCampusComponent,
    BestPracticesComponent,

    // STUDENT FACILITIES
    SportsComponent,
    CultureMusicComponent,
    ScholarshipComponent,
    HealthComponent,
    CareerGuidanceComponent,

    // GRIEVANCES
    GrievancesComponent,
    SubmitComponent,
    ObjectivesComponent,
    FunctionsComponent,
    OmbudspersonComponent,
    CommitteeComponent,
    RedressalComponent,
    PolicyComponent,

    // RESEARCH
    ResearchComponent,

    // ALUMNI
    AlumniComponent,

    // VISIT
    VisitComponent,
    HowToReachComponent,
    CityMapComponent,

    // INFO
    InfoComponent,
    NewslettersComponent,
    NotificationsComponent,
    JobOpeningsComponent,
    RtiDetailsComponent,
    RecentEventsComponent,

    // MISC
    MousComponent,
    InternshipsComponent,
    PlacementsComponent,
    ContactComponent,

    // LIBRARY
    LibraryComponent,
    AboutLibraryComponent,
    LibraryVisionMissionComponent,
    AdvisoryCommitteeComponent,
    LibraryTimingsComponent,
    LibraryRulesComponent,
    BorrowingFacilityComponent,
    IssueReturnComponent,
    EResourcesComponent,
    MoocsComponent,
    QuestionBankComponent,
    LibraryActivitiesComponent,

    // NEW COMPONENTS
    RDCellComponent,
    IncubationCentreComponent,
    NListComponent,
    AlumniComponent,
    OurAlumnusComponent,
    AlumniMeetComponent,
    InfrastructureComponent,
    GalleryComponent,
    EmailDirectoryComponent,
    TelephoneDirectoryComponent,
    ContactInfoComponent,
    AlumniLandingComponent,
    StudentFacilitiesComponent,

    // QUICK LINKS COMPONENTS
    SafetySecurityComponent,
    EResourceComponent,
    FinancialWelfareComponent,
    EducationalTripsComponent,
    AwardsComponent,
    GirlGuidesScoutsComponent,
    WorldRecordComponent,
    AthleticMeetComponent,
    SummerSportsCampComponent,
    CollegeInNewsComponent,
    SeminarsWorkshopsComponent,
    YouthFestivalComponent,
    CampusOverviewComponent,
    LatestInCollegeComponent,
    GeographyLabComponent,
    PsychologyLabComponent,
    DanceRoomComponent,
    FreeshipComponent,
    RemedialClassesComponent,
    AntiRaggingCellComponent,
    EqualOpportunityCellComponent,
    DifferentlyAbledComponent,
    SkillOrientedCoursesComponent,
    FaqComponent,
    BestPracticesHomeComponent,
    StudentLifeHomeComponent,
    PublicSelfDisclosureComponent,

    // EXCELLENCE
    BheemAwardeesComponent,
    InternationalPlayersComponent,
    NationalPlayersComponent,
    UniversityRankersComponent,
    StatePlayersComponent,
    MeritoriousStudentsComponent,

  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    PdfViewerModule
  ],
  exports: [RouterModule],
})
export class LazyMenuModule { }
